import React, { forwardRef, ReactNode } from "react";
import { a } from "kremling";

import { CpButton } from "@components";
import { RenderIconDynamic } from "../../cp-icon/render-icon-dynamic";
import { SelectDataItem } from "../common/utils";

export type TriggerSingleProps = {
  isDisabled?: boolean;
  isOpen?: boolean;
  onBlur?: (e: React.FocusEvent) => void;
  placeholder?: string;
  title?: string;
  toggle?: () => void;
  triggerIsBlock?: boolean;
  value?: SelectDataItem & {
    icon?: string | ReactNode;
    iconColor?: string;
    hideTriggerIcon?: boolean;
  };
  error?: boolean | string;
};

export const TriggerSingle = forwardRef<HTMLButtonElement, TriggerSingleProps>(
  (props, ref) => {
    const {
      isDisabled,
      isOpen,
      onBlur,
      placeholder,
      title,
      toggle,
      triggerIsBlock,
      value,
      error,
    } = props;
    return (
      <CpButton
        type="button"
        className={a("trigger-single")
          .m("trigger-single--placeholder", !value)
          .m("cp-pl-12", value?.icon)
          .m("trigger-single--error", error)}
        onClick={toggle}
        dropdown
        block={triggerIsBlock}
        ref={ref}
        disabled={isDisabled}
        onBlur={(e) => !isOpen && onBlur?.(e)}
        title={title}
      >
        <div className="flex items-center gap-2">
          {value?.icon && !value?.hideTriggerIcon && (
            <RenderIconDynamic
              icon={value.icon}
              fill={value.iconColor || "var(--cp-color-app-icon)"}
            />
          )}
          {value ? value.name : placeholder}
        </div>
      </CpButton>
    );
  },
);
